export const navStore = () => ({
  navData: [],

  init() {
    this.setData();
  },

  setData() {
    const submenus = document.querySelectorAll('.nav-submenu-data');
    this.navData = Array.from(submenus).map((submenu) => JSON.parse(submenu.textContent));
  },
});

export const navDesktopComponent = () => ({
  selectedSubmenuIdx: null,
  isHoveringSubmenu: false,
  hoveringSubmenuIdx: null,

  handleTopCategoryHover(idx) {
    this.selectedSubmenuIdx = idx;
  },

  handleTopCategoryLeave(idx) {
    if (!this.isHoveringSubmenu || this.hoveringSubmenuIdx !== idx) {
      setTimeout(() => {
        this.selectedSubmenuIdx = null;
      }, 10);
    }
  },

  handleSubmenuMouseEnter(idx) {
    this.isHoveringSubmenu = true;
    this.hoveringSubmenuIdx = idx;
  },

  handleSubmenuMouseLeave() {
    setTimeout(() => {
      this.isHoveringSubmenu = false;
      this.hoveringSubmenuIdx = null;
    }, 10);
  },
});

export const navMobileComponent = () => ({
  expandedSubmenuIndexes: [],

  handleExpandSubmenuClick(index) {
    this.expandedSubmenuIndexes = [index];
  },

  handleBackNavigation() {
    this.expandedSubmenuIndexes = [];
  },
});
